import type { AdditionalFormsFields } from '../constants/components/additional'
import type { OverriddenComponents } from '../constants/components/overrides'

export const isComponentOverridden = (
  overriddenComponentName: OverriddenComponents,
) => {
  // `maybeSelfReference = true` => prevent vue warning when resolving component is failing
  const overriddenComponent = resolveComponent(overriddenComponentName, true)
  const isOverridden = Boolean(overriddenComponent && overriddenComponent.name)

  return { isOverridden, overriddenComponent }
}

export const getAdditionalFormFields = (
  overriddenComponentName: AdditionalFormsFields,
  originalSchema: any, // TODO: Type as yup schema
) => {
  const {
    isOverridden: hasAdditionalFormFields,
    overriddenComponent: additionalFormFields,
  } = isComponentOverridden(overriddenComponentName)

  const appConfig = useAppConfig()
  const schemaToConcat
    = appConfig.additionalFormsFieldsSchemas?.[overriddenComponentName]

  if (hasAdditionalFormFields && !schemaToConcat) {
    throw createError({
      statusCode: 500,
      statusMessage: `You provided ${overriddenComponentName} fields but not the schema for it in your app config!`,
    })
  }
  if (!hasAdditionalFormFields && schemaToConcat) {
    throw createError({
      statusCode: 500,
      statusMessage: `You provided ${overriddenComponentName}'s schema in your app config but not its fields!`,
    })
  }

  const schema
    = hasAdditionalFormFields && schemaToConcat
      ? originalSchema.concat(schemaToConcat)
      : originalSchema

  return { hasAdditionalFormFields, additionalFormFields, schema }
}
